/**
 * Project panel
 *
 * Created by stefensuhat on 11/08/18 10.48 AM
 */

import { api, format } from 'utils/index';

const defaultState = {
    saved: false,
    deleted: false,
    items: [],
    item: [],
    dates: [],
    meta: {},
    errors: null,
};

export default {
    name: 'schedule',
    state: defaultState,
    reducers: {
        reset: (state) => ({ ...state, ...defaultState }),
        fetchResponse: (state, payload) => ({ ...state, items: payload.data, meta: payload.meta }),
        fetchDayResponse: (state, payload) => ({ ...state, dates: payload.dates }),
        findResponse: (state, payload) => ({ ...state, item: payload }),
        saveResponse: (state, payload) => {
            if (payload.errors) {
                return { ...state, errors: payload.errors };
            }

            return { ...state, saved: true, errors: null };
        },
        resetError: (state) => ({ ...state, errors: null }),
    },
    effects: {
        async fetch(params) {
            await api.get('schedules', { params })
                .then((response) => this.fetchResponse(response));
        },

        async fetchDays(params) {
            await api.get('schedules/disabled-days', { params })
                .then((response) => this.fetchDayResponse(response));
        },

        async find(id) {
            await api.get(`schedules/${id}`)
                .then((response) => this.findResponse(response));
        },

        async publish(date) {
            await api.post(`schedules/${date}/published`)
                .then((response) => this.saveResponse(response));
        },

        async destroy(date) {
            await api.delete(`schedules/${date}`)
                .then((response) => this.saveResponse(response));
        },

        async save(data) {
            this.resetError();

            const url = data.method === 'PUT' ? `schedules/${format(data.date, 'yyyy-MM-dd')}` : 'schedules';
            const { method } = data;

            await api.post(url, { ...data, _method: method })
                .then((response) => this.saveResponse(response));
        },
    },
    selectors: (slice, createSelector) => ({
        all() {
            return createSelector(slice, (state) => state.subscription, (subscription) => {
                const items = [];

                subscription.item.forEach((data) => {
                    const obj = {
                        ...data.scheduleable,
                        schedule_id: data.id,
                        type: data.type,
                        meals: data.meals,
                        recommended: !!data.recommended,
                        subscription: !!data.subscription,
                    };

                    return items.push(obj);
                });

                return items;
                // return subscription.items;
            });
        },
        find() {
            return createSelector(
                this.all,
                (state, selectedId) => selectedId,
                (subscriptions, selectedId) => subscriptions.find((subscription) => subscription.id === selectedId),
            );
        },
    }),
};
